export default __webpack_public_path__ + "static/media/wordofcommand.d8807e86.png";